<template>
  <v-list max-height="370" class="overflow-y-auto" dense>
    <v-list-item
      v-for="(article, index) in articles"
      :key="article.id"
      @click="goToPage(index + 1)"
      dense
      class="pa-0 my-n2"
    >
      <v-list-item-avatar tile class="ml-2">
        <MediaComponent
          v-if="article.infopairs[0]"
          :media="article.infopairs[0].media"
          :slot-width="50"
          :slot-height="50"
          thumbnail
        ></MediaComponent>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ articleTitle(article) }}</v-list-item-title>
        <v-list-item-subtitle>
          {{ showArticleEventDate(article) }}
          {{ journeyName(article) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { showDate } from '@/helpers/helpers.js'
import MediaComponent from '@/components/MediaComponent.vue'
export default {
  components: {
    MediaComponent
  },
  props: {
    articles: {
      type: Array,
      required: true
    }
  },

  methods: {
    articleTitle(article) {
      return article.title
    },
    journeyName(article) {
      if (
        article.journey_name &&
        article.journey_name != article.title &&
        article.journey_name !=
          this.$store.getters.getArticlesListOptions.searchText
      ) {
        return ' - ' + article.journey_name
      }
      return ''
    },
    goToPage(page) {
      this.$emit('gotopage', page)
    },
    showArticleEventDate(article) {
      return showDate(article.event_date, 'D MMMM YYYY')
    }
  }
}
</script>

<style></style>
